/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Members_DescriptionInputs */

const en_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your members and their subscriptions`)
};

const de_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte deine Mitglieder und ihre Tarife`)
};

const es_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra tus miembros y sus suscripciones`)
};

const fr_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérez vos membres et leurs adhésions`)
};

const it_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci i tuoi membri e i loro abbonamenti`)
};

const pt_br2_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerencie seus membros e suas assinaturas`)
};

const pl_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj swoimi członkami i ich subskrypcjami`)
};

const hu_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezelje tagjait és előfizetéseiket`)
};

const ro_admin_dashboard_empty_state_members_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Members_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionati membrii si abonamentele lor`)
};

/**
* | output |
* | --- |
* | "Manage your members and their subscriptions" |
*
* @param {Admin_Dashboard_Empty_State_Members_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_members_description = /** @type {((inputs?: Admin_Dashboard_Empty_State_Members_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Members_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_members_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_members_description(inputs)
	return ro_admin_dashboard_empty_state_members_description(inputs)
});
export { admin_dashboard_empty_state_members_description as "admin.dashboard.empty_state.members.description" }